module.exports = __webpack_public_path__ + "img/img_whzs_retail@3x.fd7b9062.png";